import { createFileRoute } from "@tanstack/react-router";

import { InvitationsPageContainer } from "@/features/settings/containers/invitations-page-container";

export const Route = createFileRoute("/settings/invitations")({
  component: InvitationsPageContainer,
});
